// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9588 ? "80dceb9d" : chunkId) + "." + {"8528":"02d67ebfea27cb15","9050":"e30c46f3aeb632d7","9588":"1500024ee6ee2a70"}[chunkId] + ".js";
};